import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b03d5634&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=b03d5634&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=b03d5634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d5634",
  null
  
)

export default component.exports